import React from 'react';
import SolidButton, { SolidButtonProps } from '../../../../../Buttons/SolidButton';

interface Props extends Omit<SolidButtonProps, 'size' | 'variant'> {}

const NeutralConfirmButton: React.FC<Props> = ({ children, ...rest }) => (
  <SolidButton size="large" variant="main" {...rest}>
    {children}
  </SolidButton>
);
NeutralConfirmButton.displayName = 'NeutralConfirmButton';

export default NeutralConfirmButton;
